import { sleep } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import { md5 } from 'js-md5';

export default createComponent(() => ({
    action: 'whisperSend',
    firstname_to:'',
    mail_to: '',
    firstname_from:'',
    mail_from:'',
    whisper_message: '',
    whisper_id_product: '',
    whisper_id_product_attribute: '',
    message: '',
    loading: false,
    submitted: false,
    error: undefined as boolean | undefined,

    setup ({whisper_id_product, whisper_id_product_attribute}) {
        this.whisper_id_product = whisper_id_product;
        this.whisper_id_product_attribute = whisper_id_product_attribute;
    },

    async submitData (event: SubmitEvent) {
        const form = event.target as HTMLFormElement;
        let formData = new FormData(form);
        formData.append('action', this.action);
        formData.append('whisper_token', md5(this.whisper_id_product + '_whisper_' + this.whisper_id_product_attribute));

        this.message = '';
        this.error = undefined;
        this.loading = true;

        try {
            const response = await fetch((this.$el as HTMLFormElement).action, {
                method: 'POST',
                body: new URLSearchParams(<any>formData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json',
                },
            });

            const data = await response.json();
            await sleep(500);

            if(data.success) {
                this.firstname_to    = '';
                this.mail_to         = '';
                this.firstname_from  = '';
                this.mail_from       = '';
                this.whisper_message = '';
            }

            this.message = data.message;
            this.error = !data.success;
            this.submitted = true;

        } catch (e) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    }
}));
